import type { Tabulator } from 'react-tabulator/lib/types/TabulatorTypes';
import type { RowComponent } from 'tabulator-tables';

//table set, text
export const boxTabulator: Tabulator.ColumnDefinition[] = [
  {
    title: 'No',
    formatter: 'rownum',
    width: 60,
    headerSort: false,
    hozAlign: 'center',
    headerHozAlign: 'center',
    resizable: false,
  },
  {
    title: '사이트 ID',
    field: 'site_id', //snake case
    widthGrow: 0.6,
    headerSort: true,
    hozAlign: 'center',
    headerHozAlign: 'center',
    resizable: false,
  },
  {
    title: '명칭',
    field: 'name',
    widthGrow: 1,
    headerSort: false,
    hozAlign: 'center',
    headerHozAlign: 'center',
    resizable: false,
  },
  {
    title: '주소',
    field: 'address',
    widthGrow: 1,
    headerSort: false,
    hozAlign: 'center',
    headerHozAlign: 'center',
    resizable: false,
  },
  {
    title: '위도',
    field: 'lat',
    widthGrow: 0.5,
    headerSort: false,
    hozAlign: 'center',
    headerHozAlign: 'center',
    resizable: false,
  },
  {
    title: '경도',
    field: 'lng',
    widthGrow: 0.5,
    headerSort: false,
    hozAlign: 'center',
    headerHozAlign: 'center',
    resizable: false,
  },
  {
    title: '접근로 수',
    field: 'number_road',
    widthGrow: 0.5,
    headerSort: false,
    hozAlign: 'center',
    headerHozAlign: 'center',
    resizable: false,
  },
  {
    title: '업데이트 일시',
    field: 'updated_time',
    widthGrow: 1,
    headerSort: true,
    hozAlign: 'center',
    headerHozAlign: 'center',
    resizable: false,
  },
];

export const optionsTabulator = (
  languageTabulator: () => Record<string, unknown>,
  count: number
) => {
  return {
    pagination: true,
    paginationSize: 10,
    rowHeight: 41,
    selectableRows: false,
    index: 'site_id',
    locale: 'ko',
    langs: {
      ko: languageTabulator(),
    },
    movableRows: false,
    resizableRows: false,
    footerElement: `<div style="padding: 0 20px 0 0; text-align: right;">총 ${count} 건</div>`,
    selectableRowsCheck: (row: RowComponent) => {
      return !row.getElement().classList.contains('tabulator-selected');
    },
    placeholder: "<div style='text-align:center;'> No Data</div>",
    //index: "site_id", // index 필드를 지정하여 행을 고유하게 식별
  };
};
